import {iosVhFix} from './utils/ios-vh-fix';
import {initModals} from './modules/modals/init-modals';
import {initAccordions} from './modules/init-accordion';
import {initTabs} from './modules/init-tabs';
// ---------------------------------

window.addEventListener('DOMContentLoaded', () => {

  // Utils
  // ---------------------------------

  iosVhFix();

  // Modules
  // ---------------------------------

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initModals();
    initAccordions();
    initTabs();

    $('input[type="phone"]').inputmask('+7 999 999 99 99');

    $(".title__play").on("click", function(){
      $('#video')[0].play();
      $('.title__play').hide();
      });
      $("#video").on("click", function(){
      $('#video')[0].pause();
      $('.title__play').show();
    });
  
    $('.gallery__slider.--index').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: true,
      centerMode: true,
  
      prevArrow: '.gallery-prev',
      nextArrow: '.gallery-next',
      responsive: [
        {
            breakpoint: 1051,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
                centerMode: false,
            }
        },
      ]
    });
    $('.gallery__slider.--about').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      variableWidth: true,
      centerMode: true,
  
      prevArrow: '.gallery-prev',
      nextArrow: '.gallery-next',
  
  
    });
  
    $('.products__right-top__slider').each(function(){
      let $this = $(this),
      $parent = $this.parents('.products__right-wrapper'),
      $nav = $parent.find('.products__right-bottom__slider');
  
      $this.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
    
        focusOnSelect: true,
        asNavFor: $nav
      });
      
      $nav.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
    
        focusOnSelect: true,
        asNavFor: $this,
        prevArrow: false,
        nextArrow: '<button class="slick-next slick-arrow custom-arrow" aria-label="Next" type="button" style=""><img src="./img/svg/arrow-bottom.svg"></button>' 
      });
    });
  
    $('[data-burger]').on('click', function() {
      let $this = $(this),
      $list = $('[data-burger-list]');
  
      if($this.hasClass('is-active')) {
        $this.removeClass('is-active');
        $list.removeClass('is-active').fadeOut(300);
        $('html').css('overflow-y', 'auto');
      } else {
        $this.addClass('is-active');
        $list.addClass('is-active').fadeIn(300);
        $('html').css('overflow-y', 'hidden');
      }
    }); 
  
    $('input[type="file"]').change(function(e){
        var fileName = e.target.files[0].name;
        $('.file-name').text(fileName);
  
        $('.mymodal__file-info').addClass('is-active');
    });
    $('.mymodal__file-clear').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      $('input[type="file"]').val('');
      $('.mymodal__file-info').removeClass('is-active');
    });
  
    if($(window).innerWidth() <= 600) {
      $('.--dropdown').on('click', function() {
        if(!$(this).hasClass('is-active')) {
          $(this).find('.header__nav-item__sub').slideDown(300);
          $(this).addClass('is-active');
        } else {
          $(this).find('.header__nav-item__sub').slideUp(300);
          $(this).removeClass('is-active');
        }
      });
    }
    $('[data-modal="feedback"]').find('form').on('submit', function(e){
      e.preventDefault();
      modals.open('success');
    });
    $('[data-modal="vacancy"]').find('form').on('submit', function(e){
      e.preventDefault();
      modals.open('success');
    });
    $('[data-modal="good"]').find('form').on('submit', function(e){
      e.preventDefault();
      modals.open('success');
    });
  
    $("a.title__link").click(function() {
      $("html, body").animate({
         scrollTop: $($(this).attr("href")).offset().top + "px"
      }, {
         duration: 500,
         easing: "swing"
      });
      return false;
   });
  
  
      // Функция ymaps.ready() будет вызвана, когда
      // загрузятся все компоненты API, а также когда будет готово DOM-дерево.
      ymaps.ready(init);
      function init(){
          // Создание карты.
          var myMap = new ymaps.Map("map", {
              // Координаты центра карты.
              // Порядок по умолчанию: «широта, долгота».
              // Чтобы не определять координаты центра карты вручную,
              // воспользуйтесь инструментом Определение координат.
              center: [55.76, 37.64],
              // Уровень масштабирования. Допустимые значения:
              // от 0 (весь мир) до 19.
              zoom: 7
          });
          myMap.behaviors.disable('scrollZoom');
      }
  });

});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
